<template>
  <projects-filter
    :selected-status-list="getSelectedStatuses()"
    @update-filter="updateFilter"
  />
  <infinite-grid-layout
    :get-items="api.project.projectStats"
    :url-params="urlParams"
    :scroll-bottom="scrollBottom"
    :one-column="currentView === '#table'"
    entity="projects"
  >
    <template #table-item="slotProps">
      <router-link :to="getLink(slotProps.item)">
        <template v-if="currentView === '#table'">
          <portfolio-project-card :project="slotProps.item" />
        </template>
        <template v-else>
          <project-card :project="slotProps.item" isPortfolio />
        </template>
      </router-link>
    </template>
  </infinite-grid-layout>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import {
    USER_ROLE_ADMINISTRATOR,
    USER_ROLE_LEADER,
  } from '@/api/models/UserRole';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';
  import {
    PROJECT_STATUS_ACCEPTANCE,
    PROJECT_STATUS_AGREEMENT,
    PROJECT_STATUS_IN_WORK,
  } from '@/api/models/ProjectStatus';
  import ProjectCard from '@/components/projects/components/ProjectCard.vue';
  import PortfolioProjectCard from '@/components/projects/portfolio/components/PortfolioProjectCard.vue';
  import ProjectsFilter from '@/components/projects/components/ProjectsFilter.vue';
  import InfiniteGridLayout from '@/components/infinite-grid/InfiniteGridLayout.vue';
  import {
    PROJECT_STATUS_NAME_ACCEPTANCE,
    PROJECT_STATUS_NAME_IN_WORK,
  } from '@/constants/project-status';

  defineProps({
    scrollBottom: Number,
  });

  const api = useApi();
  const route = useRoute();
  const currentView = computed(() => route.hash);
  const urlParams = ref(null);

  const getSelectedStatuses = () => {
    if (route.meta.role === USER_ROLE_ADMINISTRATOR) {
      return [PROJECT_STATUS_NAME_IN_WORK, PROJECT_STATUS_NAME_ACCEPTANCE];
    }
    return [];
  };

  const getLink = (project) => {
    const role = route.meta.role;

    if (role === USER_ROLE_LEADER && !project.isMyProject) {
      return `/${role}/project/` + project.id + `/form`;
    } else if (project.projectStatusId === PROJECT_STATUS_AGREEMENT) {
      return `/${role}/project/` + project.id + `/form#9`;
    } else if (project.projectStatusId === PROJECT_STATUS_ACCEPTANCE) {
      return `/${role}/project/` + project.id + `/agreement`;
    } else if (project.projectStatusId === PROJECT_STATUS_IN_WORK) {
      return `/${role}/project/` + project.id + `/management`;
    } else {
      return `/${role}/project/` + project.id + `/form`;
    }
  };

  const updateFilter = (value) => {
    const searchParams = value;
    searchParams.set('tab', 'portfolio');
    urlParams.value = searchParams;
  };
</script>

<style lang="scss" scoped></style>
